import type {FILTERED_JOB_LIST, FILTERED_JOB_PAYLOAD} from 'src/types/crm';

import type {Dispatch, GetState, ThunkAction} from 'src/reducers';
import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';

import {key, fetching} from 'src/utils/redux';


const POST_API_OPTIONS: ApiPostOptions = {
  apiPath: '/trmapi',
};

export const GET_FILTERED_JOB = 'get-filtered-job';

export type GetFilteredJobListAction = {
  type: typeof GET_FILTERED_JOB;
  payload: FILTERED_JOB_LIST;
};

export type CrmFilteredJobActions = GetFilteredJobListAction;

export const updateFilteredList = (
  payload: FILTERED_JOB_LIST,
): GetFilteredJobListAction => ({
  type: GET_FILTERED_JOB,
  payload,
});

export const getFilteredJob: (
  filteredPayload: FILTERED_JOB_PAYLOAD,
) => ThunkAction<void> = flow(
  key(
    (filteredPayload) =>
      `crm/filtered-job-list/${JSON.stringify(filteredPayload)}`,
  ),
  fetching(),
)((filteredPayload: FILTERED_JOB_PAYLOAD) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `/api/filtered-jobs`,
      {
        ...filteredPayload,
      },
      {},
      POST_API_OPTIONS,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: FILTERED_JOB_LIST) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
    (response: FILTERED_JOB_LIST) => {
      dispatch(updateFilteredList(response));
    },
    (error) => {
      // Error handling
    },
  );
});
